import { render, staticRenderFns } from "./loading-wrap.vue?vue&type=template&id=55180e05"
import script from "./loading-wrap.vue?vue&type=script&lang=js"
export * from "./loading-wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports